import { client } from './client';

// --- Readings (nested under service) ---

export const getReadingsByService = async (serviceUid) => {
    const response = await client.get(`/v1/services/${serviceUid}/readings`);
    return response.data?.items ?? response.data;
};

export const createReading = async (serviceUid, data) => {
    const response = await client.post(`/v1/services/${serviceUid}/readings`, data);
    return response.data;
};

export const updateReading = async (readingUid, data) => {
    const response = await client.put(`/v1/readings/${readingUid}`, data);
    return response.data;
};

export const deleteReading = async (readingUid) => {
    const response = await client.delete(`/v1/readings/${readingUid}`);
    return response.data;
};
